import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef } from 'vue';

import { UserModel } from '@/types';
import { useAuthStore } from '@/stores';


export default /*@__PURE__*/_defineComponent({
  __name: 'TemplateProfile',
  setup(__props, { expose: __expose }) {
  __expose();

const authStore = useAuthStore();
const user: ComputedRef<UserModel | undefined> = computed(() => authStore.userModel);

const __returned__ = { authStore, user }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})